// The app's `$filters` (`entrypoints/application.js`). On every page's boot
// path, so plain JavaScript: no utility library ships to a public page for two
// string helpers.
const WORD_PATTERN = /[\w']+/g;

export const filters = {
  initials(str) {
    const words = (str == null ? "" : String(str)).match(WORD_PATTERN) || [];

    if (words.length > 2) {
      return [words[0], words[words.length - 1]].map((w) => w[0]).join("");
    } else {
      return words.map((w) => w[0]).join("");
    }
  },
  gutMiddle(str, limit = 24) {
    const oneThird = Math.trunc(limit / 3) || 0;

    if (str.length > limit) {
      return (
        str.substr(0, oneThird) +
        "..." +
        str.substr(str.length - oneThird, str.length)
      );
    }

    return str;
  },
};
